<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull"
    @refresh="onRefresh"
  >
    <div class="page">
      <div class="games">
        <div class="game_list">
          <div
            class="game_item bg_contain"
            v-for="(item) in gameList"
            :key="item.gameId"
            :style="{ backgroundImage: `url(${item.icon})` }"
            :class="{ active_place: item.guideGameId == activeGameId }"
            @click="onChangeGame(item, true)"
          ></div>
        </div>
      </div>
      <div class="game_subline flex_between mb_12" v-if="gameInfo.gameName">
        <div class="game_name fs_18 color_black van-ellipsis">{{ gameInfo.gameName }}</div>
        <div class="game_go fs_13 text_nowrap" @click="viewGame">
          查看/下载
        </div>
      </div>
      <div class="main">
        <!-- 攻略列表 -->
        <div class="strategy-list">
          <div 
            v-for="(item, index) in strategyList" 
            :key="index"
            class="strategy-list-item"
            @click="viewStrategyDetail(item)"
            :ref="index === strategyList.length - 1 ? 'lastItem' : null"
          >
            <div class="strategy-content">
              <div class="strategy-title">
                <p class="strategy-title-main color_black fs_15 van-multi-ellipsis--l2">{{ item.title }}</p>
              </div>
              <div class="strategy-meta mb_8">
                <div class="strategy-tags van-ellipsis">
                  <span class="tag fs_10" v-for="(tag, tagIndex) in item.tagList" :key="tagIndex">#{{ tag }}</span>
                </div>
              </div>
              <div class="strategy-meta">
                <div class="strategy-actions">
                  <div class="action-item text_nowrap">
                    <!-- <van-icon :name="item.praise ? 'like' : 'like-o'" :color="item.praise ? '#F53648' : '#999'" size="16" /> -->
                    <span>{{ wrapCountFn(item.praiseNum || 0) }}人点赞</span>
                  </div>
                  <div class="action-item text_nowrap">
                    <!-- <van-icon :name="item.collect ? 'star' : 'star-o'" :color="item.collect ? '#f7be65' : '#999'" size="16" /> -->
                    <span>{{ wrapCountFn(item.collectNum || 0) }}人收藏</span>
                  </div>
                </div>
                <div class="strategy-date fs_10">{{ formatDate(item.updateTime || item.createTime) }}</div>
              </div>
              
            </div>
            <div class="strategy-cover" v-if="item.banner">
              <img :src="item.banner" alt="攻略封面" />
            </div>
          </div>
        </div>

        <!-- 加载更多 -->
        <div class="load-more" v-if="strategyList.length > 0">
          <van-loading v-if="isLoadingMore" size="24px" color="#999">加载中...</van-loading>
          <p v-else-if="noMoreData" class="no-more">没有更多数据了</p>
          <p v-else class="load-more-text" @click="loadMore">加载更多</p>
        </div>

        <!-- 空状态 -->
        <div class="empty-state" v-show="(strategyList.length === 0 && !isLoading && !fetchLoading) || noGames">
          <van-empty
            image="https://assets.hzwxbz2.cn/box/act_center/img/empty1.png"
            description="收藏夹空空如也"
            image-size="168"
          />
        </div>
      </div>
    </div>
  </PullRefresh>
</template>

<script>
import { PullRefresh, Icon, Empty } from "vant";
import { getGameStrategyListApi, getCollectedGuideListApi } from "@/apis/btBoxActivity";
import { setPageTitle } from "@/bridge/AppJsBridge";
import EventTrack from '@/mixins/eventTrack'
import Common from './common'
import LinkTo from '@/mixins/linkTo'
export default {
  mixins: [EventTrack, LinkTo, Common],
  components: {
    PullRefresh,
    [Icon.name]: Icon,
    [Empty.name]: Empty,
  },
  data() {
    return {
      isLoading: false,
      disabledPull: false,
      isLoadingMore: false,
      observer: null,
      activeGameId: '',
      gameList: [],
      strategyList: [],
      fetchLoading: true,
      lastGuideId: 0, // 替换 pageNum
      pageSize: 18, // 默认 18 条
      noGames: false,
      firstActivate: false,
    };
  },
  created() {
    if (this.$route.query.IS_DEV) {
      this.init(true);
    }
    setPageTitle('收藏攻略')
    this.getAppToken(true)
    this.$nextTick(() => {
      this.firstActivate = true
    })
  },
  activated () {
    if (this.firstActivate) {
      this.getAppToken(true)
      // this.getActivityInfo()
    }
  },
  computed: {
    activeGameInfo () {
      return this.gameList.find(item => item.guideGameId === this.activeGameId) || {}
    },
    gameInfo () {
      return this.activeGameInfo
    },
  },
  methods: {
    init(firstTime = false) {
      // this.resetList(firstTime);
      return this.getGameList(firstTime).then(res => {
        this.onTrack("guide_page", {
          page_type: 4,
        })
        return res
      })
    },
    onRefresh() {
      this.isLoading = true;
      this.init().finally(() => {
        setTimeout(() => {
          this.isLoading = false
        }, 200)
      })
    },
    getGameList (isFirst = false) {
      return getGameStrategyListApi({
        type: 2, // 1 攻略板块 2 收藏
      }, !this.isWx).then(res => {
        this.gameList = res.data || []
        if (isFirst && this.gameList.length > 0 && !this.activeGameId) {
          this.onChangeGame(this.gameList[0])
        } else if (isFirst && this.activeGameId) {
          this.onChangeGame(this.activeGameInfo)
        }
        this.noGames = !this.gameList.length
      })
    },
    getStrategyList () {
      if (!this.activeGameId) return;
      this.fetchLoading = true
      const params = {
        guideGameId: this.activeGameId,
        lastGuideId: this.lastGuideId,
        pageSize: this.pageSize,
      }
      this.isLoadingMore = this.lastGuideId > 0;

      return getCollectedGuideListApi(params, !this.isWx).then(res => {
        // 防止两个游戏的攻略接口串联
        const list = (res.data || []).filter(it => it.gameConfigId === this.activeGameId)
        
        if (this.lastGuideId === 0) {
          this.strategyList = list;
        } else {
          this.strategyList = [...this.strategyList, ...list];
        }

        // 更新 lastGuideId 为最后一条数据的 ID
        if (list.length > 0) {
          const lastItem = list[list.length - 1];
          this.lastGuideId = lastItem.guideId;
        }

        this.noMoreData = list.length < this.pageSize;
        this.isLoadingMore = false;
        
        // 数据加载完成后设置观察者
        this.$nextTick(() => {
          this.observeLastItem();
        });
      }).catch(err => {
        console.error('获取攻略列表失败:', err);
        this.isLoadingMore = false;
      }).finally(() => {
        this.fetchLoading = false
      })
    },
    onChangeGame (item, manual = false) {
      if (manual) {
        if (this.activeGameId === item.guideGameId) return
        setTimeout(() => {
          this.onTrack("guide_game_tab", {
            page_type: 4,
          })
        }, 100)
      }
      this.activeGameId = item.guideGameId
      this.resetList(true)
      this.getStrategyList()
    },
    loadMore() {
      if (this.noMoreData || this.isLoadingMore) return;
      this.getStrategyList();
    },
    resetList (clearListFlag = true) {
      this.lastGuideId = 0;
      if (clearListFlag) {
        this.strategyList = [];
      }
      this.noMoreData = false;
    },
    // 添加观察者方法
    observeLastItem() {
      // 如果已经没有更多数据或正在加载中，不需要观察
      if (this.noMoreData || this.isLoadingMore) return;
      
      // 确保之前的observer被销毁
      if (this.observer) {
        this.observer.disconnect();
      }
      
      // 创建新的观察者
      this.$nextTick(() => {
        const lastItem = this.$refs.lastItem;
        if (!lastItem) return;
        const theRef = Array.isArray(lastItem) ? lastItem[0] : lastItem
        
        this.observer = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            // 当最后一个元素进入视口时，加载更多
            this.loadMore();
          }
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0.1
        });

        this.observer.observe(theRef);
      });
    },
    viewStrategyDetail(item) {
      const { guideId, title } = item
      this.onTrack("guide_click", {
        tab_type: 2,
        page_type: 4,
        guide_id: guideId,
        guide_name: title,
      })
      this.$router.push({
        name: 'box.gameStrategyDetail',
        query: { guideId, app: this.$route.query.app }
      });
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0] + ' 更新';
    },
    getActivityInfo () {
      this.init(true);
    },
    viewGame () {
      this.onTrack("guide_view_game_button", {
        page_type: 4,
      })
      this.goGameDetail()
    },
  },
  // 在组件销毁时清理观察者
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.page {
  padding: 12px;
  min-height: 100vh;
}
.games {
  padding: 8px 12px;
  margin-bottom: 8px;
  overflow-x: auto;
  .game_list {
    display: flex;
    align-items: baseline;
    height: 66px;
    width: fit-content;
    .game_item {
      width: 52px;
      height: 52px;
      border-radius: 6px;
      filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.5));
      margin-top: 14px;
    }
    .game_item + .game_item {
      margin-left: 12px;
    }
    .active_place {
      width: 66px;
      height: 66px;
      margin-top: 0px;
      transition: all 0.1s ease;
    }
  }
}
.game_subline {
  padding: 0 16px 0 12px;
  .game_go {
    border-radius: 50px;
    padding: 10px 12px;
    background-color: #FC383C;
    color: #fff;
  }
}

.strategy-list {
  .strategy-list-item {
    display: flex;
    padding: 12px 8px;
    // border-bottom: 1px solid #f5f5f5;
    
    .strategy-content {
      width: 0;
      flex: 1;
      margin-right: 8px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      
      .strategy-title {
        margin-bottom: 8px;
        
        .strategy-title-main {
          line-height: 1.3;
        }
      }
      
      .strategy-meta {
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .strategy-tags {
          // flex-wrap: wrap;
          color: #f09900;
          .tag {
            margin-right: 6px;
          }
        }
        
        .strategy-date {
          color: #999;
          white-space: nowrap;
        }
      }
      
      .strategy-actions {
        display: flex;
        
        .action-item {
          display: flex;
          align-items: center;
          margin-right: 8px;
          
          i {
            margin-right: 4px;
          }
          
          span {
            font-size: 10px;
            color: #999;
          }
        }
      }
    }
    
    .strategy-cover {
      width: 126px;
      height: 70px;
      border-radius: 8px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .strategy-list-item + .strategy-list-item {
    margin-top: 8px;
  }
}

.load-more {
  text-align: center;
  padding: 16px 0;
  
  .load-more-text {
    color: #666;
    font-size: 14px;
  }
  
  .no-more {
    color: #999;
    font-size: 12px;
  }
}

.empty-state {
  padding: 40px 0;
}
</style>